import React, { useMemo, useCallback } from 'react';
import { View, StyleSheet, Linking } from 'react-native';
import { useAppSelector } from '@/store';
import { UserType } from '@/types/residents/user';
import { FAQContent } from '@/components/residents/redesign';
import { FaqSection, faqSectionsGuarantor, faqSectionsResident } from './faq';

const MAX_CONTENT_WIDTH = 700;

export const DesktopFAQScreen: React.FC = () => {
  const { user } = useAppSelector((state) => state.auth);

  const sections = useMemo<FaqSection[]>(() => {
    if (!user) return faqSectionsResident;
    return user.type === UserType.RESIDENT ? faqSectionsResident : faqSectionsGuarantor;
  }, [user]);

  const onSupportPress = useCallback(() => {
    const email = user?.email || '';
    const subject = encodeURIComponent('Support request');
    const body = encodeURIComponent(
      `Hi Resio Support,\r\n\r\nI'm looking for help with my account.\r\n\r\nThanks,\r\n${email}`,
    );
    Linking.openURL(`mailto:support@resio.com?subject=${subject}&body=${body}`).catch(() => {});
  }, [user?.email]);

  return (
    <View style={styles.container}>
      <View style={styles.contentWrapper}>
        <FAQContent
          sections={sections}
          onSupportPress={onSupportPress}
          showCommonErrors
          contentPaddingBottom={60}
        />
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: 'transparent',
  },
  contentWrapper: {
    flex: 1,
    maxWidth: MAX_CONTENT_WIDTH,
    alignSelf: 'center',
    width: '100%',
  },
});
